import { Feature } from "ol";
import Point from "ol/geom/Point";
import VectorLayer from "ol/layer/Vector";
import Map from "ol/Map";
import { Options } from "ol/style/Style";
import { TFunction } from "react-i18next";
import { PointOfInterestType, PTOPProjectPOIDto } from "~/api/GeneratedApi";
import { findLayerByTitle } from "~/pages/MapPage/functions/findLayerByTitle";
import { focusAnimation } from "~/pages/MapPage/functions/focusAnimation";
import { LayerTitle } from "~/pages/MapPage/types/layers";
import { PoiMapItem } from "~/pages/MapPage/types/mapItems";
import { getPoiSvgStyle } from "~/utils/hooks/useDraw";
import { getPoiIcon } from "../hooks/usePoiItems";

type DrawProjectMapOptions = {
  styleOptions?: Options;
  map: Map;
  enabled?: boolean;
  poiMarkers: PTOPProjectPOIDto[];
  showAnimation: boolean;
  setShowAnimation: React.Dispatch<React.SetStateAction<boolean>>;
  disableAnimation: boolean;
  t: TFunction<"translation">;
};
export const drawPoiItems = ({
  poiMarkers,
  enabled = true,
  map,
  showAnimation,
  setShowAnimation,
  disableAnimation,
  t,
}: DrawProjectMapOptions) => {
  const layer = findLayerByTitle(
    map,
    LayerTitle.ProjectPoiItems,
  ) as VectorLayer;
  if (!layer) return;
  const source = layer.getSource();
  if (!source) return;
  source.clear();
  if (!enabled) return;

  poiMarkers.forEach((m) => {
    if (!m.coordinates) return;
    const icon = getPoiIcon(m.type);
    const point = new Point([m.coordinates.x, m.coordinates.y]);
    const pointFeature = new Feature<Point>({ geometry: point });

    pointFeature.setStyle(getPoiSvgStyle(icon));
    pointFeature.setProperties(addPoiItemProperties(m, t));
    pointFeature.setId(`poi-item-${m.id}`);
    source.addFeature(pointFeature);

    if (showAnimation && !disableAnimation)
      focusAnimation(layer, pointFeature, map);
  });
  if (showAnimation) setShowAnimation(false);
};

function addPoiItemProperties(
  item: PTOPProjectPOIDto,
  t: TFunction<"translation">,
): PoiMapItem {
  return {
    ...item,
    type: "poi-item",
    PoiType: item.type,
    name: `POI-${t(`poi-item-enum:${PointOfInterestType[item.type]}`)}-${
      item.id
    }`,
    mapId: `poi-item-${item.id}`,
  };
}
